import semanticColorStyles from '@design/styles/SemanticColor.module.scss';
import {
  formatPercentage,
  getPriceStatus,
  PriceStatus,
} from '@helpers/utils/numbers/numbers';
import { PropsWithChildren } from 'react';

const DIRECTION_CLASS = {
  [PriceStatus.Default]: semanticColorStyles.directionNeutralSoft,
  [PriceStatus.Negative]: semanticColorStyles.directionNegative,
  [PriceStatus.Positive]: semanticColorStyles.directionPositive,
};

export const formatSignedPercent = ({
  value,
  useOriginalValue = true,
}: {
  value: number;
  useOriginalValue?: boolean;
}) =>
  formatPercentage(value, {
    useOriginalValue,
    suffix: '%',
    addPlus: true,
  });

export interface SignedChangeProps {
  value: number;
}

export const SignedChange = ({
  value,
  children,
}: PropsWithChildren<SignedChangeProps>) => (
  <span className={DIRECTION_CLASS[getPriceStatus(value)]}>{children}</span>
);
